import React, { useState } from 'react'

interface PaymentMethodProps {
  beneficiaryName?: string
  clabe?: string
  onPaymentMethodChange?: (method: 'transfer' | 'deposit') => void
  defaultMethod?: 'transfer' | 'deposit'
}

const PaymentMethod: React.FC<PaymentMethodProps> = ({
  onPaymentMethodChange,
  defaultMethod = 'transfer',
  beneficiaryName = '',
  clabe = '',
}) => {
  const [selectedMethod, setSelectedMethod] = useState<'transfer' | 'deposit'>(
    defaultMethod
  )

  const handleMethodChange = (method: 'transfer' | 'deposit') => {
    setSelectedMethod(method)
    onPaymentMethodChange?.(method)
  }

  return (
    <div className="max-w-2xl mx-auto bg-white">
      <div className="space-y-6">
        {/* Título */}
        <h3 className="text-lg font-semibold text-gray-900">
          Selecciona el método de pago:
        </h3>

        {/* Separador */}
        <hr className="border-gray-300" />

        {/* Transferencia a cuenta STP */}
        <div className="space-y-4">
          <div className="flex items-start space-x-3">
            <input
              type="radio"
              id="transfer"
              name="paymentMethod"
              value="transfer"
              checked={selectedMethod === 'transfer'}
              onChange={() => handleMethodChange('transfer')}
              className="mt-1 h-4 w-4 text-blue-600 border-olr-primary-focus border-gray-300"
            />
            <label
              htmlFor="transfer"
              className="block text-base font-medium text-gray-900 cursor-pointer"
            >
              Transferencia a cuenta STP
            </label>
          </div>

          <div className="flex items-start space-x-3">
            <div className="flex-1">
              <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                Realiza una transferencia bancaria desde tu banca en línea o app
                móvil.
              </p>

              {/* Información bancaria para transferencia */}
              <div className="mt-4 space-y-2 text-sm text-gray-700">
                <div>
                  <span className="font-semibold">Banco receptor:</span> STP
                  (Sistema de Transferencias y Pagos)
                </div>
                <div>
                  <span className="font-semibold">
                    Nombre del beneficiario:
                  </span>{' '}
                  {beneficiaryName}
                </div>
                <div>
                  <span className="font-semibold">CLABE interbancaria:</span>{' '}
                  {clabe}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Separador */}
        <hr className="border-gray-300" />

        {/* Depósito bancario en ventanilla */}
        <div className="space-y-4">
          <div className="flex items-start space-x-3">
            <input
              type="radio"
              id="deposit"
              name="paymentMethod"
              value="deposit"
              checked={selectedMethod === 'deposit'}
              onChange={() => handleMethodChange('deposit')}
              className="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
            />
            <div className="flex-1">
              <label
                htmlFor="deposit"
                className="block text-base font-medium text-gray-900 cursor-pointer"
              >
                Depósito bancario en ventanilla
              </label>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <div className="flex-1">
              <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                Acude a una sucursal bancaria y realiza el depósito directamente
                a nuestra cuenta.
              </p>

              {/* Información bancaria para depósito */}
              <div className="mt-4 space-y-2 text-sm text-gray-700">
                <div>
                  <span className="font-semibold">Banco:</span> Nombre del banco
                </div>
                <div>
                  <span className="font-semibold">
                    Nombre del beneficiario:
                  </span>{' '}
                  Razón social de la empresa
                </div>
                <div>
                  <span className="font-semibold">CLABE interbancaria:</span>{' '}
                  646180000000000000
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentMethod
